import helpers from 'lib/helpers';

import {
  React,
  Component,
  axios,
  routes,
  moment,
  TimerMixin
} from 'imports/CommonImports';

import {
  TimerIcon,
} from 'imports/IconsImports';

import {
  LinearProgress,
} from 'material-ui';


const style = {
  timer:{
    textAlign:'center',
    backgroundColor:  '#FF952B',
    padding: '5px 20px 5px 20px',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    width: '23em',
    fontSize: '0.7em',
  },
  timerIcon: {
    color: 'white',
    marginRight: '0.5em',
    width: '1.8em',
  }
}
export default class CountdownTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timer: Date.now(),
      end: false,
      loading: true,
      error: false
    }
  }

  componentDidMount() {
    if (this.props.endsAt){
      this.setState({timer: this.timeRemaining(this.props.endsAt), loading: false, deadline: this.props.endsAt})
    }
    else {
      this.getTimes();
    }
  }

  render () {
    if(this.state.end){
      return (
        <div style={style.timer} >
          <TimerIcon style={style.timerIcon}/>
          Ha terminado el periodo de evaluación
        </div>
      )
    }
    if(this.state.error){
      return(
        <div style={style.timer} >
          <TimerIcon style={style.timerIcon}/>
          <p style={{color: '#FFFFFF'}}>Error al cargar la fecha límite</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
        <div style={style.timer} >
          <TimerIcon style={style.timerIcon}/>
          <LinearProgress color='#9e9e9e'  mode="indeterminate" />
        </div>
      )
    }
    return (
      <div style={style.timer} >
        <TimerIcon style={style.timerIcon}/>
        <div>
          Fecha límite: {helpers.fullDateFormatter(new Date(this.state.deadline))}
        </div>
      </div>
    );
  }

  pastData = () => {
    return(
      <div style={style.timer} >
        <TimerIcon style={style.timerIcon}/>
        <div>
          {` Quedan ${this.state.timer.days + this.state.timer.months * 30} ${helpers.singularOrPlural(this.state.timer.days)['dia'].toLowerCase()} para terminar esta etapa`}
        </div>
      </div>
    );
  }

  tick = () => {
    const remaining = this.timeRemaining();
    if (remaining.duration.asSeconds() <= 0) {
      this.setState({end: true, timer: remaining})
      TimerMixin.clearInterval(this.timer);
    }
    this.setState({timer: remaining})
  }

  timeRemaining = (deadline) => {
    const now = moment();
    const end = moment(deadline);
    const difference = end.diff(now)
    const duration = moment.duration(difference, 'milliseconds');

    const years           = duration.years(),
          months          = duration.months(),
          days            = duration.days(),
          hours           = duration.hours(),
          minutes         = duration.minutes(),
          seconds         = duration.seconds(),
          milliseconds    = duration.milliseconds();
    return {
      years:          years < 0 ? '00' : years,
      days:           days < 0 ? '00' : days,
      months:         months < 0 ? '00' : months,
      hours:          hours < 0 ? '00' : hours,
      minutes:        minutes < 0 ? '00' : minutes,
      seconds:        seconds < 0 ? '00': seconds,
      milliseconds:   milliseconds < 0 ? '00' : milliseconds,
      duration:       duration
    };
  }

  getTimes = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.props.token}
    });
    connection.get(routes.portfolioDeadlines(this.props.company_id))
      .then((response) => {
        const deadline = response.data.deadlines.find(deadline => {return deadline.step === this.props.step});
        this.setState({
          loading: false,
          error: false,
          timer: this.timeRemaining(deadline.deadline),
          deadline: deadline.deadline,
        })
      })
      .catch((error) => {
        console.log(error);
        this.setState({ error: true, loading: false })
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/design/CountdownTimer.js